export const PROMOTION_BANNER_VIEWED = 'trial promotion banner viewed';
export const PROMOTION_BANNER_CTA_CLICKED = 'trial promotion banner CTA clicked';
export const PROMOTION_CARD_VIEWED = 'trial promotion card viewed';